import { Route, Routes } from 'react-router-dom';
import ProfileShow from './Show';
import ProfileLayout from '@koob/profile/src/layouts/ProfileLayout';
import ProfileNotificationPreferences from './NotificationPreferences';
import { useApp } from '../../hooks';
import { decodeId } from '../../utils';
import KoobSpinner from '@koob/ui/src/components/KoobSpinner';
import KoobLayout from '../../components/Koob/KoobLayout';

export default function ProfileContainer() {
  const { user } = useApp();
  const userId = decodeId(user?.id);

  return user ? (
    <KoobLayout>
      <ProfileLayout user={user}>
        <Routes>
          <Route path="/" element={<ProfileShow />} />
          <Route
            path="/notification-preferences"
            element={<ProfileNotificationPreferences userId={userId} />}
          />
        </Routes>
      </ProfileLayout>
    </KoobLayout>
  ) : (
    <KoobSpinner />
  );
}
